









































































import Vue from 'vue';

import addADeck from '@/lib/helpers/addDeck';
import * as ping from '@/lib/usage_ping';
import { Repository } from '@/db/_repo';
import { DeckService } from '@/lib/services/DeckService';
const db = new Repository();
const deckService = new DeckService();

import avatar       from '@/components/users/avatar.vue';
import sideitem     from '@/components/app-nav/sidebar-deck.vue';
import explore      from '@/components/app-buttons/btnExplore.vue';
import iDeck        from '@/components/decks/deck-import.vue';

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { orderBy } from 'lodash';

import { UserAnswers } from '../../models/UserAnswers';

export default Vue.extend({
    components: {
        avatar,
        'sidebar-item': sideitem,
        explore,
        'import-deck': iDeck,
    },
    data() {
        return {
            selectedDeckId: '',
            showExplore: false,
            isTourSkip: false, //This is just so I can pass "this" to addADeck
            showImportModal: false,
            tourCallbacks: {
                onNextStep: function (currentStep) {
                    if (currentStep === 0) {
                        const btnNewDeck = document.getElementById('btnNewDeck');
                        btnNewDeck.click();
                    }
                }
            }
        }
    },
    mounted() {
        document.getElementById('sidebar').addEventListener('click', function(e) {
            let closeMe = true;
            if (e.srcElement["id"] == "mobile-menu") closeMe = false;
            if (e.target['className'].indexOf("doNotClose") > -1) closeMe = false;

            if (closeMe) {
                setTimeout(() => {
                    document.getElementById("sidebar").classList.add("hide-on-med-and-down");
                }, 250);
            }
        }, false);
    },
    async created() {

        await this.loadAllDecks();

        try {
            // TODO: this should be a vuex action
            let answers = await db.decks.getAllUserAnswersAsync(this.currentUser.uid);
            this.UPDATE_USER_ANSWERS(answers);
        }
        
        catch(e){
            console.error(e);
            this.$toast.open({
                message: 'There was an error fetching due cards.',
                type: 'error',
                duration: 3000,
                position: 'top-right'
            });
        }
    },
    methods: {
        ...mapActions([
            "getAllPrivateDecks",
            "getAllSharedDecks"
        ]),
        deckDueCardsCount(deckId) {
            return deckService.deckDueCardsCount(deckId);
        },
        addDeck() {
            addADeck(this.currentUser.uid, this);
        },

        async loadAllDecks() {
            try {
                this.getAllPrivateDecks(this.currentUser),
                this.getAllSharedDecks(this.currentUser)
            }
            catch (err) {
                //TODO: This exposes the fact that there IS something and it's not your standard 404.
                //we should only error when it's in dev mode
                console.error(err);
                this.permissionError = true;
            }
        },
        ...mapMutations([
            'UPDATE_USER_ANSWERS'
            ]),
    },
    computed: {
        ...mapGetters({
            privateUserDecks: 'privateUserDecks',
            sharedUserDecks: 'sharedUserDecks'
        })
    }
});
